import { render, staticRenderFns } from "./SetServiceSpeed.vue?vue&type=template&id=238e4788&scoped=true&"
import script from "./SetServiceSpeed.vue?vue&type=script&lang=js&"
export * from "./SetServiceSpeed.vue?vue&type=script&lang=js&"
import style0 from "./SetServiceSpeed.vue?vue&type=style&index=0&id=238e4788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e4788",
  null
  
)

export default component.exports